import { Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import Layout from "@/components/layout/Layout";
import SEO from "@/components/SEO";

const allReviews = [
  { name: "Emma S.", rating: 5, text: "Absolutely beautiful work! The bottle art was even better than I imagined. Perfect anniversary gift." },
  { name: "James R.", rating: 5, text: "The custom painting of our dog was incredible. So much detail and care went into it. Highly recommend!" },
  { name: "Sophie L.", rating: 5, text: "Ordered a wedding bottle for my best friend — she cried happy tears! Fast delivery too." },
  { name: "David M.", rating: 5, text: "Second time ordering and the quality is consistently amazing. The family portrait was spot on." },
  { name: "Chloe P.", rating: 4, text: "Lovely bottle art, exactly what I described. Communication was great throughout the process." },
  { name: "Tom W.", rating: 5, text: "Surprised my wife with a custom painting for our anniversary. She absolutely loved it. Thank you!" },
  { name: "Rachel K.", rating: 5, text: "Such a unique gift idea. Everyone at the party asked where I got it. Will definitely order again." },
  { name: "Lucy H.", rating: 5, text: "The attention to detail is incredible. It's clear this is made with real love and care." },
];

const avgRating = (allReviews.reduce((sum, r) => sum + r.rating, 0) / allReviews.length).toFixed(1);

const Reviews = () => {
  return (
    <Layout>
      <SEO title="Reviews · Soft Chaos Studio" description="Read customer reviews for Soft Chaos Studio's handmade gifts and custom artwork." canonical="/reviews" jsonLd={{"@context":"https://schema.org","@type":"Product","name":"Soft Chaos Studio","aggregateRating":{"@type":"AggregateRating","ratingValue":"4.9","reviewCount":"8","bestRating":"5"}}} />
      <section className="container py-16">
        <h1 className="text-4xl font-serif font-semibold text-center mb-3">Customer Reviews</h1>
        <p className="text-center text-muted-foreground mb-8">Hear from the people who've received our handmade gifts.</p>

        {/* Overall rating */}
        <div className="bg-blush rounded-lg p-8 text-center max-w-md mx-auto mb-12">
          <p className="text-5xl font-serif font-bold mb-2">{avgRating}</p>
          <div className="flex justify-center gap-1 mb-2">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star key={i} size={20} className="fill-primary text-primary" />
            ))}
          </div>
          <p className="text-sm text-muted-foreground">Based on {allReviews.length} reviews</p>
        </div>

        {/* Review cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {allReviews.map((review, i) => (
            <div key={i} className="bg-card rounded-lg p-6 shadow-card">
              <div className="flex gap-1 mb-3">
                {Array.from({ length: review.rating }).map((_, j) => (
                  <Star key={j} size={14} className="fill-primary text-primary" />
                ))}
              </div>
              <p className="text-sm text-muted-foreground mb-4 italic">"{review.text}"</p>
              <p className="font-medium text-sm">{review.name}</p>
            </div>
          ))}
        </div>

        {/* Leave review CTA */}
        <div className="text-center mt-12 bg-sage rounded-lg p-10 max-w-xl mx-auto">
          <h3 className="font-serif text-xl font-semibold mb-3">Love your gift?</h3>
          <p className="text-sm text-muted-foreground mb-5">We'd love to hear from you! Leave us a review on Facebook.</p>
          <a href="https://www.facebook.com/profile.php?id=61586838426531" target="_blank" rel="noopener noreferrer">
            <Button>Leave a Review</Button>
          </a>
        </div>
      </section>
    </Layout>
  );
};

export default Reviews;
